import * as auth from './auth';
import * as user from './user';
import * as administrator from './administrator';
import * as profile from './profile';
import * as author from './author';
import * as serie from './serie';
import * as book from './book';

export const ApiManager = () => {
  return {
    auth,
    user,
    administrator,
    profile,
    author,
    serie,
    book,
  };
};
